module.exports = __webpack_public_path__ + "static/pipeline-code-3-03e22208c94402d5f92a56465d31d6da.png";